import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import TipButton from '../components/TipButton';
import CustomSliderMessage from '../components/CustomSliderMessage';
import ChatDropdown from '../components/ChatDropdown';
import rightarrow from '../assets/images/right.svg';
import drop_vertical from '../assets/images/drop_vertical.svg';
import tip_icon from '../assets/images/tip_icon.svg';
import loaderIcon from '../assets/images/loader.gif';
import verified from '../assets/images/verified.svg';
import heart_icon_fill_message from '../assets/images/heart_icon_fill.svg';
import msgload from '../assets/images/ds.gif';
import config from '../config/config';

const ChatMessage = () => {
const { user_id } = useParams();
const scrollableDivRef = useRef(null);  
const { user_id: receiverId } = useParams();
const [userData, setUserData] = useState({ email: '', user_name: '' });
const [users, setUsers] = useState([]);
const [priority, setPriorityUsers] = useState([]); 
const [unread, setUnreadUsers] = useState([]);   
const [isSearchVisible, setSearchVisible] = useState(false);
const [isSearchVisibleChat, setSearchVisibleChat] = useState(false);
const [loading, setLoading] = useState(true);
const [chatHistory, setChatHistory] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [filter, setFilter] = useState('all');
const [sortedUsersalldelete, setSortedUsersallDelete] = useState([]);
const [receiverDetails, setReceiverDetails] = useState({});
const [toastMessage, setToastMessage] = useState('');
const [toastType, setToastType] = useState('');
const navigate = useNavigate();
const [messageContent, setMessageContent] = useState("");
const [mediaFiles, setMediaFiles] = useState([]);
const [previewImages, setPreviewImages] = useState([]);
const [previewVideos, setPreviewVideos] = useState([]);    // define this state for video previews

const [mutedUsers, setMutedUsers] = useState(new Set());
const [filteredMessages, setFilteredMessages] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const [liked, setLiked] = useState(false);
const [heartVisible, setHeartVisible] = useState(false);
const [likedMessages, setLikedMessages] = useState({});
const [showModal, setShowModal] = useState(false); 
const [showToast, setShowToast] = useState(false);
const [errorMessage, setErrorMessage] = useState('');
const [selectedReportReason, setSelectedReportReason] = useState('');
const [replyContent, setReplyContent] = useState('');
const [replyMessageId, setReplyMessageId] = useState(null);
const [isUserScrolling, setIsUserScrolling] = useState(false);
const [walletBalance, setWalletBalance] = useState(0);  
const { user_id: activeUserId } = useParams();
const messageRefs = useRef({}); // Store refs for messages
const [likeText, setLikeText] = useState('Like');
const [isSubmitting, setIsSubmitting] = useState(false);


  const chatUser = receiverDetails ? {
    id: receiverDetails.user_id,
    name: receiverDetails.name,
    user_name: receiverDetails.user_name,
    profile: receiverDetails.profile,
    online_status: receiverDetails.online_status,
    message_notification_status: receiverDetails.message_notification_status
  } : null;

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
        setWalletBalance(user.wallet_balance); 

      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const fetchChatUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      let url = `${config.baseURL}/chatable-users?type=all`;
      
      // Adjust URL or parameters based on filter
      if (filter === 'newest') {
        url += '&sort=newest';
      } else if (filter === 'oldest') {
        url += '&sort=oldest';
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsers(response.data.chat_users || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching chat users', err);
    }
  };

// Call fetchChatUsers inside useEffect
useEffect(() => {
  fetchChatUsers();
}, [filter, navigate]);


// Sort users based on the selected filter
  const sortedUsersall = users
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (filter === 'newest') {
        return new Date(b.message_time) - new Date(a.message_time);
      } else if (filter === 'oldest') {
        return new Date(a.message_time) - new Date(b.message_time);
      }
      return 0; // Default is no sorting
    });


const fetchChatUsersPriority = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      let url = `${config.baseURL}/chatable-users?type=priority`;
      
      // Adjust URL or parameters based on filter
      if (filter === 'newest') {
        url += '&sort=newest';
      } else if (filter === 'oldest') {
        url += '&sort=oldest';
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPriorityUsers(response.data.chat_users || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching chat users', err);
    }
  };

// Call fetchChatUsersPriority inside useEffect
useEffect(() => {
  fetchChatUsersPriority();
}, [filter, navigate]);


// Sort users based on the selected filter
  const sortedUserspriority = priority
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (filter === 'newest') {
        return new Date(b.message_time) - new Date(a.message_time);
      } else if (filter === 'oldest') {
        return new Date(a.message_time) - new Date(b.message_time);
      }
      return 0; // Default is no sorting
  });


  const priorityCount = priority.length;

const fetchChatUsersUnread = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      let url = `${config.baseURL}/chatable-users?type=unread`;
      
      // Adjust URL or parameters based on filter
      if (filter === 'newest') {
        url += '&sort=newest';
      } else if (filter === 'oldest') {
        url += '&sort=oldest';
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUnreadUsers(response.data.chat_users || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching chat users', err);
    }
  };

// Call fetchChatUsersUnread inside useEffect
useEffect(() => {
  fetchChatUsersUnread();
}, [filter, navigate]);



// Sort users based on the selected filter
  const sortedUsersunread = unread
    .filter(user =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (filter === 'newest') {
        return new Date(b.message_time) - new Date(a.message_time);
      } else if (filter === 'oldest') {
        return new Date(a.message_time) - new Date(b.message_time);
      }
      return 0; // Default is no sorting
    });

  const unreadCount = unread.length;

    const fetchChatHistory = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/Login');
        return;
      }

      try {
        const response = await axios.get(`${config.baseURL}/get-messages`, {
          params: { user_id },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        if (response.data.success) {
          // Filter out messages that are hidden
          const visibleMessages = response.data.messages.filter(message => message.is_hidden !== "true");
          setChatHistory(visibleMessages); // Update chat history with visible messages
          setReceiverDetails(response.data.receiver_details);
          setFilteredMessages(visibleMessages); // Update filtered messages as well
        }
      } catch (error) {
        console.error("Error fetching chat history:", error);
      } finally {
        setLoading(false);
      }
    };

    // Effect to fetch chat history on user ID change
    useEffect(() => {
      fetchChatHistory();
    }, [user_id]);


  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const toggleSearch = () => {
    setSearchVisible(!isSearchVisible);
  };

  const closeSearch = () => {
    setSearchVisible(false);
  };


  const toggleSearchChat = () => {
    setSearchVisibleChat(!isSearchVisibleChat);
  };

  const closeSearchChat = () => {
    setSearchVisibleChat(false);
  };



  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

  const handleUserClick = (user_id) => {
    navigate(`/chatmessage/${user_id}`); 
  };

const isMuted = receiverDetails.message_notification_status === 'false';

const handleMuteNotification = (e, userId) => {
  e.preventDefault();

  const url = `${config.baseURL}/mute-message-notification`;
  const token = localStorage.getItem('token');

  // Get the current mute status
  const isCurrentlyMuted = receiverDetails.message_notification_status === 'false'; // Assume 'false' means muted

  const formData = new URLSearchParams();
  formData.append('user_id', userId);
  formData.append('mute', isCurrentlyMuted ? 'true' : 'false'); // Toggle mute status

  axios.post(url, formData, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .then(response => {
    if (response.data.success) {
      // Update the status based on the API response
      const newStatus = isCurrentlyMuted ? 'true' : 'false'; // Toggle the status
      receiverDetails.message_notification_status = newStatus;

      // Set success toast message using API response message
      setToastMessage(response.data.message || (isCurrentlyMuted ? 'Notification unmuted successfully!' : 'Notification muted successfully!'));
      setToastType('success');
    } else {
      // Set error toast message from API response
      setToastMessage(response.data.message || 'Failed to update notification status. Please try again.');
      setToastType('error');
    }

    // Clear the toast message after 3 seconds
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 3000);
  })
  .catch(error => {
    console.error('Error updating notification status:', error);
    
    // Set error toast message from API error response
    const errorMessage = error.response?.data?.message || 'Failed to update notification status. Please try again.';
    setToastMessage(errorMessage);
    setToastType('error');

    // Clear the toast message after 3 seconds
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 3000);
  });
};




const formatMessageTime = (messageTime) => {
  // Try to create a date object from the messageTime string
  let messageDate;
  try {
    // Create a Date object using the ISO format
    messageDate = new Date(messageTime);
    
    // Check if the date is valid
    if (isNaN(messageDate.getTime())) {
      throw new Error('Invalid date');
    }
  } catch (error) {
    console.error('Error parsing date:', messageTime, error);
    return 'Invalid Date';
  }

  const now = new Date();
  
  // Check if the message is from today
  const isToday = messageDate.toDateString() === now.toDateString();

  // Check if the message is from yesterday
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday = messageDate.toDateString() === yesterday.toDateString();

  // Format the message time
  if (isToday) {
    return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  } else if (isYesterday) {
    return "Yesterday";
  } else {
    return messageDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
};


const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  const newMediaFiles = [...mediaFiles, ...files];
  setMediaFiles(newMediaFiles);

  const newPreviewImages = [];
  const newPreviewVideos = [];

  files.forEach((file) => {
    const fileURL = URL.createObjectURL(file);
    if (file.type.startsWith("image/")) {
      newPreviewImages.push(fileURL);
    } else if (file.type.startsWith("video/")) {
      newPreviewVideos.push(fileURL);
    }
  });

  setPreviewImages((prev) => [...prev, ...newPreviewImages]);
  setPreviewVideos((prev) => [...prev, ...newPreviewVideos]);
};


const handleRemoveMedia = (index, isVideo = false) => {
  // Remove video or image preview
  if (isVideo) {
    const newPreviewVideos = previewVideos.filter((_, i) => i !== index);
    setPreviewVideos(newPreviewVideos);
  } else {
    const newPreviewImages = previewImages.filter((_, i) => i !== index);
    setPreviewImages(newPreviewImages);
  }

  // Update the media files array (images and videos)
  const newMediaFiles = mediaFiles.filter((_, i) => i !== index);
  setMediaFiles(newMediaFiles);
};


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!messageContent && mediaFiles.length === 0) {
    return;
  }

  setIsSubmitting(true);  // Disable the button

  const formData = new FormData();
  formData.append("receiver_id", receiverId);
  formData.append("content", messageContent);

  if (replyMessageId) {
    formData.append("reply_of", replyMessageId);
  }

  mediaFiles.forEach((file, index) => {
    formData.append(`media[${index}]`, file);
  });

  const token = localStorage.getItem('token');

  try {
    const tempMessage = {
      id: `temp-${Date.now()}`,
      sender_id: userData.id,
      receiver_id: receiverId,
      is_auth_user_message: true,
      content: messageContent,
      is_liked: "false",
      is_hidden: "false",
      seen: "false",
      reply_of: replyMessageId,
      created_at: new Date().toISOString(),
      media: [],
    };

    setChatHistory(prev => [...prev, tempMessage]);

    const response = await axios.post(`${config.baseURL}/send-message`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`,
      },
    });

    setMessageContent("");
    setMediaFiles([]);
    setPreviewImages([]);
    setReplyContent('');
    setReplyMessageId(null);

    fetchChatHistory();
    fetchChatUsers();
    fetchChatUsersPriority();
    fetchChatUsersUnread();
  } catch (error) {
    console.error("Failed to send message:", error);
    setChatHistory(prev => prev.filter(msg => msg.id !== `temp-${Date.now()}`));
  } finally {
    setIsSubmitting(false);  // Enable the button again
  }
};


  // added by h 

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchChatUsers();
      fetchChatUsersPriority();
      fetchChatUsersUnread();
    }, 1000); // Fetch every 10 seconds
  
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);



  const scrollToMessage = (messageId) => {
    const targetMessage = messageRefs.current[messageId];
    if (targetMessage) {
      targetMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
  
      // Highlight the message temporarily
      targetMessage.classList.add('highlight');
      setTimeout(() => targetMessage.classList.remove('highlight'), 2000);
    }
  };
  





const handleMarkAllAsRead = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    await axios.post(`${config.baseURL}/message/mark-all-read`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    // Fetch the updated list of users or notifications
    const response = await axios.get(`${config.baseURL}/chatable-users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setUsers(response.data.chat_users || []);
    setLoading(false);
  } catch (err) {
    console.error('Error marking all as read:', err.response ? err.response.data : err.message);
  }
};

  const handleCloseModal = () => {
    document.body.classList.remove('modal-open-message_lightbox_gallery');
    setShowModal(false);
  };

const formatDate = (dateString) => {
  const messageDate = new Date(dateString);
  const today = new Date();

  if (
    messageDate.getDate() === today.getDate() &&
    messageDate.getMonth() === today.getMonth() &&
    messageDate.getFullYear() === today.getFullYear()
  ) {
    return "Today";
  }

  return messageDate.toLocaleDateString([], {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
};


const handleClearMessage = async (userId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${config.baseURL}/clear-message`, {
            params: {
                receiver_id: userId,
            },
            headers: {
                Authorization: `Bearer ${token}`, // Replace `yourToken` with the actual token variable
            },
        });

        if (response.status === 200) {
            // Successfully cleared the message, now update the state
            setSortedUsersallDelete(prevUsers =>
                prevUsers.map(user =>
                    user.user_id === userId ? { ...user, last_message: "" } : user
                )
            );
            // Fetch chat users to reflect the updated list
            fetchChatUsers();
            fetchChatUsersPriority();
            fetchChatUsersUnread();
        }
    } catch (error) {
        console.error("Failed to clear the message", error);
    }
};

// Function to copy message
const copyMessage = (messageContent) => {
  if (messageContent && typeof messageContent === 'string') {
    navigator.clipboard.writeText(messageContent)
      .then(() => {
        // Set success toast message
        setToastMessage('Message copied to clipboard!');
        setToastType('success');
        // Clear the toast message after 3 seconds
        setTimeout(() => {
          setToastMessage('');
          setToastType('');
        }, 3000);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        // Set error toast message
        setToastMessage('Failed to copy message.');
        setToastType('error');
        // Clear the toast message after 3 seconds
        setTimeout(() => {
          setToastMessage('');
          setToastType('');
        }, 3000);
      });
  } else {
    // Set no content toast message
    setToastMessage('No content to copy.');
    setToastType('warning');
    // Clear the toast message after 3 seconds
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 3000);
  }
};


// Function to like a message
const likeMessage = async (messageId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${config.baseURL}/like-message`,
      { message_id: messageId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    // Check API response for success or error
    if (response.data.success) {
      // Update liked status for this message
      setLikedMessages((prev) => ({
        ...prev,
        [messageId]: true,
      }));

      fetchChatHistory();
    }
  } catch (error) {
    console.error('Error liking message:', error);
  }
};

// Function to unlike a message
const unlikeMessage = async (messageId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${config.baseURL}/like-message`,  // Use the same endpoint
      { message_id: messageId },         // Send the same message_id
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    // Check API response for success or error
    if (response.data.success) {
      // Update liked status for this message
      setLikedMessages((prev) => ({
        ...prev,
        [messageId]: false,
      }));

      // Fetch chat history again to get updated message status
      fetchChatHistory();
    }
  } catch (error) {
    console.error('Error unliking message:', error);
  }
};


// Function to reply to a message with media and content
const replyToMessage = (replyContent, messageId) => {
  setReplyContent(replyContent); // Set the content of the reply
  setReplyMessageId(messageId);   // Set the ID of the message being replied to
};


  
// Modify the search functionality to handle null or undefined content
const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    if (!value) {
      setFilteredMessages(chatHistory);
      return;
    }

    const filtered = chatHistory.map((message) => ({
      ...message,
      content: highlightText(message.content, value),
    }));

    setFilteredMessages(filtered);
  };

  const highlightText = (text) => {
    if (!searchTerm) return text;

    const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        `<mark>${part}</mark>`
      ) : (
        part
      )
    ).join('');
  };

// Function to scroll the div to the bottom
const scrollToBottom = () => {
  if (scrollableDivRef.current) {
    scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
  }
};

// Add scroll event listener to track if the user scrolls up
useEffect(() => {
  const handleScroll = () => {
    if (scrollableDivRef.current) {
      const scrollPosition = scrollableDivRef.current.scrollTop + scrollableDivRef.current.clientHeight;
      const scrollHeight = scrollableDivRef.current.scrollHeight;

      // If the user scrolls up or is not at the bottom, mark as not scrolling
      const isAtBottom = Math.abs(scrollPosition - scrollHeight) < 5; // Small tolerance for precision
      setIsUserScrolling(!isAtBottom); // True if the user has scrolled up
    }
  };

  if (scrollableDivRef.current) {
    scrollableDivRef.current.addEventListener('scroll', handleScroll);
  }

  // Clean up event listener when component unmounts
  return () => {
    if (scrollableDivRef.current) {
      scrollableDivRef.current.removeEventListener('scroll', handleScroll);
    }
  };
}, []); // Empty dependency array since this effect only needs to run once on mount

// Auto-scroll when new messages are added and the user is at the bottom
useEffect(() => {
  if (!isUserScrolling) {
    scrollToBottom();
  }
}, [chatHistory]); // Only run this effect when the chat history changes


function highlightlinkText(content) {
  const urlPattern = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
  return content.replace(urlPattern, function(url) {
    // Add "http://" prefix to URLs that start with "www."
    const href = url.startsWith('www.') ? `http://${url}` : url;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

 
const [reportReason, setReportReason] = useState('');
const reportReasons = [
  "I don't like the messages of this user",
  'Violates OnlyFans Terms of Service',
  'Contains copyrighted material (DMCA)',
  'Child Sexual Abuse Material (CSAM)',
  'Report Spam',
  'Report Abuse',
];

const handleReportUser = (userId) => {
  setSelectedReportReason(''); // Reset the selected reason
  setReportReason(userId); // Set the userId for the report
  setShowModal(true);
};
const handleModalSubmit = async (e) => {
  e.preventDefault();
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${config.baseURL}/report-user`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        report_to: reportReason,
        reason: selectedReportReason,
      }),
    });

    const data = await response.json();

    // Show toast message based on API response
    if (data.success) {
      setToastMessage('Report submitted successfully!'); // Set success message
      setToastType('success'); // Set toast type to success

    } else {
      setToastMessage(data.message || 'Failed to submit report.'); // Set error message from response
      setToastType('error'); // Set toast type to error
    }
  } catch (error) {
    console.error('Error reporting user:', error);
    setToastMessage('Error reporting user.'); // Set generic error message
    setToastType('error'); // Set toast type to error
  } finally {
    // Clear the toast message after 3 seconds
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 3000);

    // Hide the modal
    setShowModal(false);
  }
};


// Function to hide a message
const handleHideMessage = async (messageId) => {
  try {
    const token = localStorage.getItem('token'); 
    const response = await axios.post(
      `${config.baseURL}/hide-message`,
      {
        message_id: messageId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          'Content-Type': 'application/json', 
        },
      }
    );
    
    // Log the API response only
    console.log(response.data);
    
    // Refresh the message history after hiding the message
    await fetchChatHistory(); // Fetch the updated messages

  } catch (error) {
    console.error('Error hiding message:', error);
    // Handle error (e.g., show a notification to the user)
  }
};

// old code 
//  useEffect(() => {
//       const intervalId = setInterval(fetchChatHistory, 1000); // Fetch messages every second
//       return () => clearInterval(intervalId); // Cleanup on unmount
//   }, []);
useEffect(() => {
  if (user_id) {
    fetchChatHistory();
    const intervalId = setInterval(fetchChatHistory, 10000);
    return () => clearInterval(intervalId);
  }
}, [user_id]); // Make sure user_id is in the dependency array


  useEffect(() => {
    document.title = " Messages - PatreonPass";
  }, []);


  return (
    <div>

      <div className="main_patreonpass_wrapper">

      {toastMessage && (
        <div className={`toast-message ${toastType}`}>
          {toastMessage}
        </div>
      )}


        <div className="patreonpass_container chat_message_history_wrap">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="chat_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>Messages</h1>
                  </div>
                   <div className="create_post_btn">
                          <button
                            className="create_post_btn_area verify_btn search_btn_chat"
                            id="searchButton"
                            onClick={toggleSearch}
                          >
                            <svg
                              className="heading_search_icon"
                              width={38}
                              height={38}
                              viewBox="0 0 38 38"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                stroke="#242529"
                                strokeWidth="3.88235"
                              />
                              <path
                                d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                fill="#242529"
                              />
                            </svg>

                          </button>

                          <Link to="/chatsend" className="create_post_btn_area verify_btn search_btn_chat chat_start">
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 27.5H49" stroke="black" stroke-width="7.41379" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M27.5 49V6" stroke="black" stroke-width="7.41379" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </Link>  

                        </div>
                        {isSearchVisible && (
                          <div id="searchContainer" className="collection_search">
                            <button
                              id="closeButton"
                              className="create_post_btn_area verify_btn search_btn_chat close_btn_search_after"
                              onClick={closeSearch}
                            >
                              <svg
                                width={54}
                                height={54}
                                viewBox="0 0 54 54"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 49L49 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M49 49L5 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <input
                              type="text"
                              id="searchInput"
                              placeholder="Search"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button>
                              <svg
                                className="heading_search_icon"
                                width={38}
                                height={38}
                                viewBox="0 0 38 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                  stroke="#00aff0"
                                  strokeWidth="3.88235"
                                />
                                <path
                                  d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                  fill="#00aff0"
                                />
                              </svg>
                            </button>
                          </div>
                        )}
                </div>

                
                <div className="chat_message_block">
                    <div className="post_top_section_head">
                      <div className="title_post_head">NEWEST FIRST</div>
                      <div className="title_post_head_shorting">
                        <div className="shorting_icons my_profile_menu">
                          <a
                            href="#"
                            className="shorting_lists"
                            id="productsDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <svg
                              width={54}
                              height={54}
                              viewBox="0 0 54 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 44H15.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4 27H32.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4 10H49.3333"
                                stroke="#8A96A3"
                                strokeWidth="7.08333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                          <ul className="dropdown-menu" aria-labelledby="productsDropdown">
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="all"
                                  name="status"
                                  checked={filter === 'all'}
                                  onChange={() => setFilter('all')}
                                />
                                <label htmlFor="all" className="dropdown-item">
                                  All
                                </label>
                              </li>
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="newest"
                                  name="status"
                                  checked={filter === 'newest'}
                                  onChange={() => setFilter('newest')}
                                />
                                <label htmlFor="newest" className="dropdown-item">
                                  Newest First
                                </label>
                              </li>
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="oldest"
                                  name="status"
                                  checked={filter === 'oldest'}
                                  onChange={() => setFilter('oldest')}
                                />
                                <label htmlFor="oldest" className="dropdown-item">
                                  Oldest First
                                </label>
                              </li>
                              <li className="dropdown">
                                <input
                                  type="radio"
                                  id="mark-all-read"
                                  name="status"
                                />
                                <label
                                  htmlFor="mark-all-read"
                                  className="dropdown-item"
                                  onClick={handleMarkAllAsRead}
                                >
                                  Mark all as read
                                </label>
                              </li>
                            </ul>
                        </div>
                      </div>
                    </div>
                    
                    <div className="chat_pills">
                      <div className="pill_tabs">
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link active"
                              id="pills-all-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-all"
                              type="button"
                              role="tab"
                              aria-controls="pills-all"
                              aria-selected="true"
                            >
                              All
                            </button>
                          </li>
                          {priorityCount > 0 && (
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="pills-following-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-following"
                              type="button"
                              role="tab"
                              aria-controls="pills-following"
                              aria-selected="false"
                              tabIndex={-1}
                            >
                              {" "}
                               Priority <span className="countdown">{priorityCount}</span>
                            </button>
                          </li>
                          )}
                           {unreadCount > 0 && (
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="pills-trending-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-trending"
                              type="button"
                              role="tab"
                              aria-controls="pills-trending"
                              aria-selected="false"
                              tabIndex={-1}
                            >
                              Unread <span className="countdown">{unreadCount}</span>
                            </button>
                          </li>
                           )}
                        </ul>
                      </div>
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade active show"
                          id="pills-all"
                          role="tabpanel"
                          aria-labelledby="pills-all-tab"
                        >
                          {/* Content for All */}
                          <div className="chat_user_list">
  {loading ? (
    <div className="loader-overlay sm">
      <img src={msgload} alt="Loading..." /></div>
  ) : sortedUsersall.length > 0 ? (
    sortedUsersall
      .filter((user) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.username.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((user) => (
        <Link
          to={`/chatmessage/${user.user_id}`}
          className={`chate_user_block ${
            activeUserId === String(user.user_id) ? 'actv' : '' // Add 'actv' if user_id matches activeUserId
          } ${
            (user.seen === 'true' && !user.is_auth_user_message) || user.is_auth_user_message
              ? 'seen'
              : ''
          } ${
            user.message_notification_status === 'false' || user.message_notification_status === false
              ? 'mute'
              : ''
          }`}
          key={user.user_id}
        >
          <div className="client-img">
            <div className="lazy-container user_image">
              <div
                className={user.user_online_status === 'online' ? 'user_online_status online' : ''}
              >
                {user.profile ? (
                  <img src={user.profile} alt={`${user.name} Image`} />
                ) : (
                  <div className="user_initials">{getInitials(user.name)}</div>
                )}
              </div>
            </div>
          </div>
          <div className="chat_message_inside_list">
            <div className="chat_message_top_right">
              <div className="chat_message_top_right_left">
                <span>
                  {user.name} <img src={verified} />
                </span>
                <span className="chat_username">@{user.username}</span>
              </div>
              <div className="chat_message_top_right_right">
                <div
                  className="close_icon_chat"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClearMessage(user.user_id);
                  }}
                >
                  <svg
                    width={54}
                    height={54}
                    viewBox="0 0 54 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 49L49 5"
                      stroke="#8A96A3"
                      strokeWidth="7.52867"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M49 49L5 5"
                      stroke="#8A96A3"
                      strokeWidth="7.52867"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="chat_message_bottom_right">
              <div className="chat_message_bottom_right_left">
                <ul className="list_below_name chat-inside-list">
                  {user.media && user.media.length > 0 && !user.last_message && (
                    <li>
                      <svg
                        className="img-inside_chate"
                        width={38}
                        height={38}
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                          fill="#242529"
                        />
                        <circle
                          cx="2.7766"
                          cy="2.7766"
                          r="2.7766"
                          transform="matrix(-1 0 0 1 16.7227 11.1704)"
                          fill="#242529"
                        />
                        <path
                          d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                          stroke="#242529"
                          strokeWidth="3.39362"
                          strokeLinecap="round"
                        />
                      </svg>
                      Media Attached
                    </li>
                  )}
                  {user.last_message && <li>{user.last_message}</li>}
                </ul>
              </div>
              <div className="chat_message_bottom_right_right">
                <span>{formatMessageTime(user.message_time)}</span>
                {/* Show mute icon only if message_notification_status is false or 'false' */}
                {(user.message_notification_status === 'false' || user.message_notification_status === false) && (
                  <span className="mte">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 38 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3379 28.5444C14.7265 29.9692 15.8921 32.4301 19.0006 32.4301C20.5549 32.4301 23.3525 31.9638 23.6634 28.5444"
                        stroke="#8A96A3"
                        strokeWidth="3"
                      />
                      <path
                        d="M4.23438 27.7661H33.7651"
                        stroke="#8A96A3"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                      <path
                        d="M29.49 27.3781V14.7431C29.49 14.6184 29.4793 14.4912 29.4561 14.3687C28.1368 7.37948 21.9517 5.87898 18.9989 6.00737C16.055 6.00742 9.82248 7.67711 8.17606 14.3161C8.13709 14.4733 8.11914 14.6374 8.11914 14.7994V27.3781"
                        stroke="#8A96A3"
                        strokeWidth="3"
                      />
                      <path
                        d="M34.3945 33.8421L3.9998 4"
                        stroke="#8A96A3"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                )}
                <span className="dot_sky" />
              </div>
            </div>
          </div>
        </Link>
      ))
  ) : (
    <p className="no_list">No chat users available.</p>
  )}
</div>


   
                        </div>
                        {priorityCount > 0 && (
                        <div
                          className="tab-pane fade"
                          id="pills-following"
                          role="tabpanel"
                          aria-labelledby="pills-following-tab"
                        >
                          {/* Content for Priority  */}
                           <div className="chat_user_list">                                 
                              {loading ? (
                                <p>Loading...</p>
                              ) : sortedUserspriority.length > 0 ? (
                                sortedUserspriority
                                  .filter((user) =>
                                    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    user.username.toLowerCase().includes(searchTerm.toLowerCase())
                                  )
                                  .map((user) => (
                                   <Link
                                      to={`/chatmessage/${user.user_id}`}
                                      className={`chate_user_block ${
                                        (user.seen === "true" && !user.is_auth_user_message) || user.is_auth_user_message ? "seen" : ""
                                      }`}
                                      key={user.user_id}
                                    >
                                    <div className="client-img">
                                      <div className="lazy-container user_image">
                                        <div className={user.user_online_status === 'online' ? 'user_online_status online' : ''}>
                                          {user.profile ? (
                                            <img src={user.profile} alt={`${user.name} Image`} />
                                          ) : (
                                            <div className="user_initials">
                                             {getInitials(user.name)} 
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="chat_message_inside_list">
                                      <div className="chat_message_top_right">
                                        <div className="chat_message_top_right_left">
                                          <span>{user.name} <img src={verified} /></span>
                                          <span className="chat_username"> @{user.username} </span>
                                        </div>
                                        <div className="chat_message_top_right_right">
                                          <div className="close_icon_chat">
                                            <svg
                                              width={54}
                                              height={54}
                                              viewBox="0 0 54 54"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M5 49L49 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <path
                                                d="M49 49L5 5"
                                                stroke="#8A96A3"
                                                strokeWidth="7.52867"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="chat_message_bottom_right">
                                        <div className="chat_message_bottom_right_left">
                                          <ul className="list_below_name chat-inside-list">
                                            {user.media && user.media.length > 0 && !user.last_message && (
                                              <li>
                                                <svg
                                                  className="img-inside_chate"
                                                  width={38}
                                                  height={38}
                                                  viewBox="0 0 38 38"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                                                    fill="#242529"
                                                  />
                                                  <circle
                                                    cx="2.7766"
                                                    cy="2.7766"
                                                    r="2.7766"
                                                    transform="matrix(-1 0 0 1 16.7227 11.1704)"
                                                    fill="#242529"
                                                  />
                                                  <path
                                                    d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                                                    stroke="#242529"
                                                    strokeWidth="3.39362"
                                                    strokeLinecap="round"
                                                  />
                                                </svg>
                                                Media Attached
                                              </li>
                                            )}
                                            {user.last_message && (
                                              <li>{user.last_message}</li>
                                            )}
                                          </ul>
                                        </div>
                                        <div className="chat_message_bottom_right_right">
                                          <span>{formatMessageTime(user.message_time)}</span>
                                          <span className="dot_sky" />
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                ))
                              ) : (
                                <p className="no_list">No chat users available.</p>
                              )}
                            </div>
                        </div>
                        )}
                        {unreadCount > 0 && (
                        <div
                          className="tab-pane fade"
                          id="pills-trending"
                          role="tabpanel"
                          aria-labelledby="pills-trending-tab"
                        >
                        {/* Content for Unread */}
{/* Content for Unread */}
<div className="chat_user_list">
  {loading ? (
    <p>Loading...</p>
  ) : sortedUsersunread.length > 0 ? (
    sortedUsersunread
      .filter((user) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.username.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((user) => (
        <Link
          to={`/chatmessage/${user.user_id}`}
          className={`chate_user_block ${
            (user.seen === 'true' && !user.is_auth_user_message) || user.is_auth_user_message
              ? 'seen'
              : ''
          } ${
            user.message_notification_status === 'false' || user.message_notification_status === false
              ? 'mute'
              : ''
          }`}
          key={user.user_id}
        >
          <div className="client-img">
            <div className="lazy-container user_image">
              <div
                className={user.user_online_status === 'online' ? 'user_online_status online' : ''}
              >
                {user.profile ? (
                  <img src={user.profile} alt={`${user.name} Image`} />
                ) : (
                  <div className="user_initials">{getInitials(user.name)}</div>
                )}
              </div>
            </div>
          </div>
          <div className="chat_message_inside_list">
            <div className="chat_message_top_right">
              <div className="chat_message_top_right_left">
                <span>
                  {user.name} <img src={verified} alt="verified" />
                </span>
                <span className="chat_username">@{user.username}</span>
              </div>
              <div className="chat_message_top_right_right">
                <div
                  className="close_icon_chat"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClearMessage(user.user_id); // Assuming you have a function for clearing the chat
                  }}
                >
                  <svg
                    width={54}
                    height={54}
                    viewBox="0 0 54 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 49L49 5"
                      stroke="#8A96A3"
                      strokeWidth="7.52867"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M49 49L5 5"
                      stroke="#8A96A3"
                      strokeWidth="7.52867"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="chat_message_bottom_right">
              <div className="chat_message_bottom_right_left">
                <ul className="list_below_name chat-inside-list">
                  {user.media && user.media.length > 0 && !user.last_message && (
                    <li>
                      <svg
                        className="img-inside_chate"
                        width={38}
                        height={38}
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                          fill="#242529"
                        />
                        <circle
                          cx="2.7766"
                          cy="2.7766"
                          r="2.7766"
                          transform="matrix(-1 0 0 1 16.7227 11.1704)"
                          fill="#242529"
                        />
                        <path
                          d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                          stroke="#242529"
                          strokeWidth="3.39362"
                          strokeLinecap="round"
                        />
                      </svg>
                      Media Attached
                    </li>
                  )}
                  {user.last_message && <li>{user.last_message}</li>}
                </ul>
              </div>
              <div className="chat_message_bottom_right_right">
                <span>{formatMessageTime(user.message_time)}</span>
                 {/* SVG Icon with the "mte" class - Added below */}
          {user.message_notification_status === 'false' || user.message_notification_status === false ? (
            <span className="mte">
              <svg width="15" height="15" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.3379 28.5444C14.7265 29.9692 15.8921 32.4301 19.0006 32.4301C20.5549 32.4301 23.3525 31.9638 23.6634 28.5444"
                  stroke="#8A96A3"
                  strokeWidth="3"
                ></path>
                <path
                  d="M4.23438 27.7661H33.7651"
                  stroke="#8A96A3"
                  strokeWidth="3"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M29.49 27.3781V14.7431C29.49 14.6184 29.4793 14.4912 29.4561 14.3687C28.1368 7.37948 21.9517 5.87898 18.9989 6.00737C16.055 6.00742 9.82248 7.67711 8.17606 14.3161C8.13709 14.4733 8.11914 14.6374 8.11914 14.7994V27.3781"
                  stroke="#8A96A3"
                  strokeWidth="3"
                ></path>
                <path
                  d="M34.3945 33.8421L3.9998 4"
                  stroke="#8A96A3"
                  strokeWidth="3"
                  strokeLinecap="round"
                ></path>
              </svg>
            </span>
          ) : null}
                <span className="dot_sky" />
              </div>
            </div>
          </div>

         
        </Link>
      ))
  ) : (
    <p className="no_list">No unread chat users available.</p>
  )}
</div>



                        </div>
                        )}
                      </div>
                    </div>

                  </div>

              </div>
            </div>
            

            <div className="right_main_content chat_messages_list">
                    <div className="page_title_with_dropdown notification_page main_chat_header">
                      <div className="page_heading">
                        <button className="profile_back_btn" onClick={handleBackClick}>
                          <svg
                            width={54}
                            height={54}
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                              stroke="#222"
                              strokeWidth={6}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <div className="chat_header">
                          <h1>
                            {receiverDetails.name}  
                            <img className="chat_user_details" src={verified} alt="" />{" "}
                          </h1>
                          <ul className="chat_header_below_list">
                            <li>
                              <span className="chat_user_status">
                                <span
                                  className={
                                    receiverDetails.online_status === 'online' ? 'user_online' : ''
                                  }
                                />
                                {receiverDetails.online_status === 'online'
                                  ? 'Available now'
                                  : receiverDetails.online_status}
                              </span>
                            </li>

                             <li>
                              <Link
                                onClick={(e) => handleMuteNotification(e, receiverDetails.user_id)}
                              >
                                {isMuted ? (
                                  <svg
                                  width={40}
                                  height={40}
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.3379 28.5444C14.7265 29.9692 15.8921 32.4301 19.0006 32.4301C20.5549 32.4301 23.3525 31.9638 23.6634 28.5444"
                                    stroke="#8A96A3"
                                     strokeWidth={3}
                                  />
                                  <path
                                    d="M4.23438 27.7661H33.7651"
                                    stroke="#8A96A3"
                                     strokeWidth={3}
                                    strokeLinecap="round"
                                  />
                                  <path
                                    d="M29.49 27.3781V14.7431C29.49 14.6184 29.4793 14.4912 29.4561 14.3687C28.1368 7.37948 21.9517 5.87898 18.9989 6.00737C16.055 6.00742 9.82248 7.67711 8.17606 14.3161C8.13709 14.4733 8.11914 14.6374 8.11914 14.7994V27.3781"
                                    stroke="#8A96A3"
                                     strokeWidth={3}
                                  />
                                  <path
                                    d="M34.3945 33.8421L3.9998 4"
                                    stroke="#8A96A3"
                                     strokeWidth={3}
                                    strokeLinecap="round"
                                  />
                                </svg>
                                ) : (
                                  <svg
                                    width={38}
                                    height={38}
                                    viewBox="0 0 38 38"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M13.6328 29.9565C14.0802 31.5969 15.4223 34.4302 19.0012 34.4302C20.7907 34.4302 24.0118 33.8934 24.3697 29.9565"
                                      stroke="#8A96A3"
                                      strokeWidth={3}
                                    />
                                    <path
                                      d="M2 29.0601H36"
                                      stroke="#8A96A3"
                                      strokeWidth={3}
                                      strokeLinecap="round"
                                    />
                                    <path
                                      d="M31.0779 28.6136V14.0664C31.0779 13.9228 31.0655 13.7763 31.0389 13.6352C29.5199 5.58825 22.3987 3.86067 18.999 4.00848C15.6096 4.00854 8.43379 5.93093 6.53819 13.5747C6.49332 13.7557 6.47266 13.9447 6.47266 14.1311V28.6136"
                                      stroke="#8A96A3"
                                      strokeWidth={3}
                                    />
                                  </svg>
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link to={`/chatmessage/${user_id}/gallery`}>
                                <svg
                                  width={38}
                                  height={38}
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                                    fill="#8A96A3"
                                  />
                                  <circle
                                    cx="2.7766"
                                    cy="2.7766"
                                    r="2.7766"
                                    transform="matrix(-1 0 0 1 16.7227 11.1704)"
                                    fill="#8A96A3"
                                  />
                                  <path
                                    d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                                    stroke="#8A96A3"
                                    strokeWidth="3.39362"
                                    strokeLinecap="round"
                                  />
                                </svg>
                                Gallery
                              </Link>
                            </li>                          
                           
                          </ul>
                        </div>
                      </div>
                      <ChatDropdown receiverId={receiverId} /> 
                      {isSearchVisibleChat && (
                      <div id="searchContainerChat" className="collection_search chat_search">
                            <button
                              id="closeButton"
                              className="create_post_btn_area verify_btn search_btn_chat close_btn_search_after"
                              onClick={closeSearchChat}
                            >
                              <svg
                                width={54}
                                height={54}
                                viewBox="0 0 54 54"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 49L49 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M49 49L5 5"
                                  stroke="#8A96A3"
                                  strokeWidth="7.52867"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                            <input
                              type="text"
                              className="form-control"
                              id="searchInputChat"
                              placeholder="Find in Chat"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <button>
                              <svg
                                className="heading_search_icon"
                                width={38}
                                height={38}
                                viewBox="0 0 38 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M30.9109 17.3353C30.9109 24.7219 24.8843 30.7294 17.426 30.7294C9.96774 30.7294 3.94118 24.7219 3.94118 17.3353C3.94118 9.94871 9.96774 3.94118 17.426 3.94118C24.8843 3.94118 30.9109 9.94871 30.9109 17.3353Z"
                                  stroke="#00aff0"
                                  strokeWidth="3.88235"
                                />
                                <path
                                  d="M33.6317 36.3769C34.392 37.1327 35.6211 37.1291 36.3769 36.3688C37.1327 35.6085 37.1291 34.3794 36.3688 33.6236L33.6317 36.3769ZM36.3688 33.6236L29.144 26.4412L26.4068 29.1945L33.6317 36.3769L36.3688 33.6236Z"
                                  fill="#00aff0"
                                />
                              </svg> 
                          </button>
                     </div>
                      )
                    }
                    </div>
                    <div className="chat-container">
                     <div className="middle_part_chats chat_message_history" ref={scrollableDivRef}>
                    {loading ? (
                      <div className="loader-container">
                        <img src={loaderIcon} alt="Loading..." className="loading_icon" />
                      </div>
                    ) : filteredMessages.length > 0 ? (
                      filteredMessages.map((message, index) => {
                        const currentMessageDate = formatDate(message.created_at);
                        const previousMessageDate = index > 0 ? formatDate(filteredMessages[index - 1].created_at) : null;

                        // Find the original message if this is a reply
                        const originalMessage = filteredMessages.find(m => m.id === message.reply_of);

                        return (
                          <div>
                              {currentMessageDate !== previousMessageDate && (
                              <div className="date-divider">
                                <span>{currentMessageDate}</span>
                              </div>
                            )}
                          <div
    key={message.id}
    ref={(el) => {
      if (el && message.media && message.media.length > 0) {
        messageRefs.current[message.id] = el; // Store refs only for media messages
      }
    }}
    className={message.is_auth_user_message ? "own_message" : "sender_message"}
  >
   
                          
                            <div className={message.is_auth_user_message ? "own_message" : "sender_message"}>
                              <div className={message.is_auth_user_message ? "my_message" : "sender_user"}>
                                {!message.is_auth_user_message && (
                                  <div className="lazy-container user_image chat_user_img">
                                    <div className={receiverDetails.online_status && receiverDetails.online_status.startsWith("Last seen:") ? '' : 'user_online_status online'}>
                                      {receiverDetails.profile ? (
                                        <img src={receiverDetails.profile} alt={`${receiverDetails.name} Image`} />
                                      ) : (
                                        <div className="user_initials">
                                          {getInitials(receiverDetails.name)}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="sender_content">
                                {/* Handling replies */}
                                {originalMessage && (
  <div className="reply_message">
    <div className="reply_message_top">
      <span>{originalMessage.is_auth_user_message ? "You" : receiverDetails.name}</span>{", "}
      <span className="reply_time">
        {new Date(originalMessage.created_at).toLocaleString('default', { month: 'short', day: 'numeric' })}, 
       {" "} {new Date(originalMessage.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </span>
    </div>
    <div className="reply_message_bottom">
      <span>
        {originalMessage.content || " "}
      </span>
      <div className="media_icons">
        {/* Render image icon if there is an image */}
        {originalMessage.media.some((m) => m.file_type === "image") && (
          <svg
            width={20}
            height={20}
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
              fill="#8A96A3"
            />
            <circle
              cx="2.7766"
              cy="2.7766"
              r="2.7766"
              transform="matrix(-1 0 0 1 16.7227 11.1704)"
              fill="#8A96A3"
            />
            <path
              d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
              stroke="#8A96A3"
              strokeWidth="3.39362"
              strokeLinecap="round"
            />
          </svg>
        )}
        {/* Render video icon if there is a video */}
        {originalMessage.media.some((m) => m.file_type === "video") && (
          <svg
          width={20}
          height={20}
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.8627 10.4512H5.8904C4.84636 10.4512 4 11.2975 4 12.3416V40.5492C4 42.7583 5.79086 44.5492 7.99999 44.5492H36.8627C39.0719 44.5492 40.8627 42.7583 40.8627 40.5492V14.4512C40.8627 12.242 39.0719 10.4512 36.8627 10.4512Z"
            stroke="#8A96A3"
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.0005 15.52L40.8633 23.8141V30.7259L51.0005 39.9416V15.52Z"
            stroke="#8A96A3"
            strokeWidth={5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        
        )}
      </div>
    </div>

    {/* Show 'View Message' button only for media messages */}
    {originalMessage.media && originalMessage.media.length > 0 && (
      <button
        className="view_message_button"
        onClick={() => scrollToMessage(originalMessage.id)}
      >
        View Message
      </button>
    )}
  </div>
)}


                                <div className="chat_column">
                                  <div className="sender_drop_action dropdown">
                                    <a
                                      href="#"
                                      className="vertical_small_drop_icon"
                                      id={`messageDropdown-${message.id}`}
                                      role="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                     <svg
                                        width={59}
                                        height={59}
                                        viewBox="0 0 59 59"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0_62_102)">
                                          <path
                                            d="M29.5007 19.6668C32.2171 19.6668 34.4173 17.4666 34.4173 14.7502C34.4173 12.0337 32.2171 9.8335 29.5007 9.8335C26.7842 9.8335 24.584 12.0337 24.584 14.7502C24.584 17.4666 26.7842 19.6668 29.5007 19.6668ZM29.5007 24.5835C26.7842 24.5835 24.584 26.7837 24.584 29.5002C24.584 32.2166 26.7842 34.4168 29.5007 34.4168C32.2171 34.4168 34.4173 32.2166 34.4173 29.5002C34.4173 26.7837 32.2171 24.5835 29.5007 24.5835ZM29.5007 39.3335C26.7842 39.3335 24.584 41.5337 24.584 44.2502C24.584 46.9666 26.7842 49.1668 29.5007 49.1668C32.2171 49.1668 34.4173 46.9666 34.4173 44.2502C34.4173 41.5337 32.2171 39.3335 29.5007 39.3335Z"
                                            fill="#8A96A3"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_62_102">
                                            <rect width={59} height={59} fill="white" />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby={`messageDropdown-${message.id}`}>
                                      {message.content && message.media.length === 0 && (
                                        <li className="dropdown">
                                          <Link
                                            className="dropdown-item"
                                            onClick={() => copyMessage(message.content)}
                                          >
                                            Copy
                                          </Link>
                                        </li>
                                      )}
                                      {!message.is_auth_user_message && (
                                      <li className="dropdown">
                                        <Link
                                          className="dropdown-item"
                                          onClick={message.is_liked === "true" ? () => unlikeMessage(message.id) : () => likeMessage(message.id)}
                                        >
                                          {message.is_liked === "true" ? <span>Unlike</span> : 'Like'}
                                        </Link>
                                      </li>
                                      )}
                                      <li className="dropdown">
                                        <Link
                                          className="dropdown-item"
                                          onClick={() => replyToMessage(message.content, message.id)}
                                        >
                                          Reply
                                        </Link>
                                      </li>
                                      {!message.is_auth_user_message && (
                                      <li className="dropdown">
                                        <Link
                                          className="dropdown-item"
                                          onClick={() => handleHideMessage(message.id)} // Call the hide function
                                        >
                                          Hide
                                        </Link>
                                      </li>
                                      )}
                                      {!message.is_auth_user_message && (
                                        <li className="dropdown">
                                          <Link onClick={() => handleReportUser(message.sender_id)} className="dropdown-item">
                                            Report
                                          </Link>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                  <div className="sender_content_full">
                                    <div className="sender_text_block">
                                      {message.media && message.media.length > 0 && (
                                        <CustomSliderMessage media={message.media} />
                                      )}
                                      {message.content && (
                                        <p
                                          className="message-content"
                                          dangerouslySetInnerHTML={{ __html: highlightlinkText(message.content) }}
                                        />
                                      )}
                                    </div>
                                   <div className="sender_time_dates">
  <span className="message_like">
    {message.is_liked === "true" && (
      <span><img src={heart_icon_fill_message} /></span>
    )}
  </span>
  {new Date(message.created_at).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit', 
    hour12: true 
  })}
  {message.is_auth_user_message && (
    <span className="message-status">
      {/* Single tick for sent message */}
      <svg 
        width="18" 
        height="18" 
        viewBox="0 0 24 24" 
        className="tick-icon single-tick"
      >
        <path 
          fill="#8A96A3" 
          d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        />
      </svg>
      
      {/* Double tick for seen message */}
      {message.seen === "true" && (
        <svg 
          width="18" 
          height="18" 
          viewBox="0 0 24 24" 
          className="tick-icon double-tick"
        >
          <path 
            fill="#8a96a3" 
            d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41z"
          />
        </svg>
      )}
    </span>
  )}
</div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="no_list">No messages found.</p>
                    )}
                  </div>


                    </div>  
                    <div className="chat_footer">
                        {/* <form className="chat_form" onSubmit={handleSubmit}> */}
                        <form 
  className="chat_form" 
  onSubmit={handleSubmit}
  onKeyPress={(e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  }}
>
                            {replyMessageId && (
                              <div className="reply-preview">
                                <span>" {replyContent}</span>
                                <button type="button" className="reply_message_btn" onClick={() => {
                                  setReplyContent(''); // Clear the reply content
                                  setReplyMessageId(null); // Clear the reply message ID
                                }}>X</button>
                              </div>
                            )}

                          {/* Image Previews */}
                          <div className="image-preview image_preview_chat">
                          {previewImages.length > 0 && (

  <div className="image-previewyy">
    {previewImages.map((src, index) => (
      <div className="image-preview-item" key={index}>
        <img className="preview-image" src={src} alt={`Preview ${index + 1}`} />
        <button className="remove-image-btn" type="button" onClick={() => handleRemoveMedia(index)}>
          X
        </button>
      </div>
    ))}
  </div>
)}

{previewVideos.length > 0 && (
  <div className="image-previewyy">
    {previewVideos.map((src, index) => (
      <div className="image-preview-item" key={index}>
        <video className="preview-image" controls>
          <source src={src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <button className="remove-image-btn" type="button" onClick={() => handleRemoveMedia(index, true)}>
          X
        </button>
      </div>
    ))}
  </div>
)}

</div>

  
  
                          <textarea
                            autoComplete="on"
                            maxLength={20000}
                            id="new_post_text_input"
                            placeholder="Type a message..."
                            rows={1}
                            value={messageContent}
                            onChange={(e) => setMessageContent(e.target.value)}
                          />
                          <div className="chat_form_bottom">
                            <div className="chat_upload_media">
                              <div className="chat_upload_media_file">
                                <input
                                  type="file"
                                  id="fileUpload"
                                  className="hidden"
                                  multiple
                                  onChange={handleFileChange}
                                  accept="image/*,video/*" // Accept only images and videos
                                />
                                <label htmlFor="fileUpload">
                                  <svg
                                  width={38}
                                  height={38}
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M10.0752 29.0639H28.9371C29.4673 29.0639 29.7506 28.4395 29.4015 28.0406L24.2302 22.1306C24.0036 21.8716 23.6089 21.848 23.3531 22.0782L18.066 26.8366C17.8291 27.0498 17.4689 27.0475 17.2347 26.8314L14.0993 23.9372C13.8456 23.703 13.4491 23.7226 13.2196 23.9806L9.61401 28.037C9.26031 28.4349 9.54278 29.0639 10.0752 29.0639Z"
                                    fill="#8A96A3"
                                  />
                                  <circle
                                    cx="2.7766"
                                    cy="2.7766"
                                    r="2.7766"
                                    transform="matrix(-1 0 0 1 16.7227 11.1704)"
                                    fill="#8A96A3"
                                  />
                                  <path
                                    d="M34 5.61702V33.383C34 33.7237 33.7238 34 33.383 34H5.61702C5.27625 34 5 33.7237 5 33.383V5.61702C5 5.27625 5.27625 5 5.61702 5H33.383C33.7238 5 34 5.27625 34 5.61702Z"
                                    stroke="#8A96A3"
                                    strokeWidth="3.39362"
                                    strokeLinecap="round"
                                  />
                                </svg>
                                </label>
                              </div>
                            </div>
                            <div className="chat_submit_btn">
  <button type="submit" className="create_post_btn_area post_btn" disabled={isSubmitting}>
    Send
  </button>
</div>
                          </div>
                        </form>
                        <div className="tip_icon_chat">
                          <TipButton 
                          imageSrc={tip_icon} 
                          userId={user_id}
                          user={chatUser}
                          walletBalance={walletBalance}               
                          />
                        </div>
                      </div>
                  </div>
          </div>
        </div>


         {showModal && (
          <>
            <div className="modal-overlay-dark" onClick={handleCloseModal}></div>
            <div className="modal restoreAccessModalAccess fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="restoreAccessModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="restoreAccessModalLabel">Report</h5>
                  </div>
                  <div className="modal-body">
                    <form id="reportUserForm" onSubmit={handleModalSubmit}>
                      <div className="form-group">
                        {reportReasons.map((reason, index) => (
                          <div className="form-check" key={index}>
                            <input 
                              className="form-check-input" 
                              type="radio" 
                              name="reportReason" 
                              id={`reportReason${index}`} 
                              value={reason} 
                              onChange={(e) => setSelectedReportReason(e.target.value)} 
                              required 
                            />
                            <label className="form-check-label" htmlFor={`reportReason${index}`}>
                              {reason}
                            </label>
                          </div>
                        ))}
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary cancel_btn" onClick={handleCloseModal}>Cancel</button>
                        <button type="submit" className="btn btn-primary send_btn" disabled={!selectedReportReason}>Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}            


      </div>
    </div>
  );
};

export default ChatMessage;
